import { PARTNER_SERVICES_URL_SEEK_PASS } from '@seek/adv-constants';
import { siteConfig, type Locale } from '@seek/melways-sites';

import type { EmployerSiteNames } from 'src/siteConfig';

export const seekPassFindOutMore = ({
  site,
  locale,
}: {
  site: EmployerSiteNames;
  locale: Locale;
}): string => {
  const path = 'seek-employers?internal_link=true';
  const country = siteConfig[site].classification.country;

  if (country === 'id' && locale === 'en-ID') {
    return `${PARTNER_SERVICES_URL_SEEK_PASS}id/en-id/${path}`;
  }
  if (country === 'th' && locale === 'en-TH') {
    return `${PARTNER_SERVICES_URL_SEEK_PASS}th/en-th/${path}`;
  }

  return `${PARTNER_SERVICES_URL_SEEK_PASS}${country}/${path}`;
};
